export const USER_ROLES: { role: string; value: number }[] = [
    {role: "SUPER_ADMIN", value: 1},
    {role: "ADMIN", value: 2},
    {role: "CONTENT_OWNER", value: 3},
    {role: "USER", value: 4},
    {role: "CUSTOM_ROLE", value: 6},
    {role: "EVENTS_ANNOUNCEMENTS_ADMIN_ROLE", value: 8},
    {role: "BHE_CONTENT_MANAGER", value: 9},
];

export const PRECEPTOR_OPTION = {role: "PRECEPTOR", value: 5};